import axios from 'axios';
import apisUrls from '../urls';

const toggleAppPackageApi = (data) => {
  return axios.post(apisUrls?.toggleAppPackage, data, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
};

export default toggleAppPackageApi;
